const eventTarget = new EventTarget()

export function dispatchSnackbar(message, variant = "success") {
    eventTarget.dispatchEvent(
        new CustomEvent("snackbar", {
            detail: { message, variant },
        })
    )
}

export function subscribeAlert(listener) {
    const handler = (event) => {
        const { message, variant } = event.detail
        listener(message, variant)
    }

    eventTarget.addEventListener("snackbar", handler)
    return () => eventTarget.removeEventListener("snackbar", handler)
}